import * as PropTypes from "prop-types";
import {connect} from "react-redux";
import {Component} from "react";
import * as React from "react";
import {Card, CardBody, CardHeader} from "reactstrap";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Read-only panel zobrazující způsob platby.
 */
class ZpusobPlatbyPanel extends Component<WithTranslation> {

    static propTypes = {
        zpusobPlatba: PropTypes.object.isRequired, // VO způsobu platby
        cenovaNabidka: PropTypes.bool, // zda je vyžadována cenová nabídka, implicitně false
    };

    static defaultProps = {
        cenovaNabidka: false,
    };

    render() {
        const {zpusobPlatba, cenovaNabidka, t} = this.props;
        return <Card>
            <CardHeader>
                <h2>{t('way_of_payment')}</h2>
            </CardHeader>
            <CardBody>
                {`${zpusobPlatba.nazevZpusobPlatba}${cenovaNabidka ? `, ${t('send_price_offer_first')}` : ""}`}
            </CardBody>
        </Card>
    }
}

export default connect()(withTranslation()(ZpusobPlatbyPanel));
